<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_servicerequest_info.path')" :paths="paths"
        id="service-request-info-g-page-title"
      ></g-page-title>
    </template>
    <g-contents>

      
        <div class="-p-5">
          <section class="-wrapper-column -wrapper-tile">
            <div class="-header">
              <p class="-h2"
                id="service-request-info-header"
              >{{ $t('pages_servicerequest_info.path') }}</p>
            </div>

            <div class="-width-100 -tile-container nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table -pb-0">
                  <div class="-row">
                    <div class="-row-header" style="width: 15%;">
                      <h5 class="-font-size-12"
                        id="service-request-info-subject-label"
                      >{{ $t('pages_servicerequest.info.subject') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-subject-content"
                      >
                        <span class="-font-size-14 -mr-1">{{ serviceRequest.subject }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div class="-width-100 -tile-container -wrapper-half nowrap- white-space-normal">

              <section class="-wrapper-tile">
                <div class="-div-table -py-0">
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-customer-name-label"
                      >{{ $t('pages_servicerequest.info.customerName') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-customer-name-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.customer && serviceRequest.customer.customerName">{{ serviceRequest.customer.customerName }}  </span>
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-requester-label"
                      >{{ $t('pages_servicerequest.info.requester') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-requester-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.requester && serviceRequest.requester.name">{{ serviceRequest.requester.name }} </span>
                      </p>
                    </div>
                  </div>

                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-responder-name-label"
                      >{{ $t('pages_servicerequest.info.responderName') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-responder-name-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.responderName">{{ serviceRequest.responderName }} </span>
                      </p>
                    </div>
                  </div>

                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-link-label"
                      >{{ $t('pages_servicerequest.info.link') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-link-content"
                      >
                        <span class="-font-size-14 -mr-2 -ellipsis" v-if="serviceRequest.link">
                          <a  :href="serviceRequest.link" target="_blank">
                            {{ serviceRequest.link }}
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>

                </div>
              </section>

              <section class="-wrapper-tile">
                <div class="-div-table -py-0">
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-status-label"
                      >{{ $t('pages_servicerequest.info.status') }}</h5>
                    </div>
                    <div class="-row-contents"
                      id="service-request-info-status-content"
                    >
                      <p :class="!!serviceRequestStatusCombo.find(status => status.value == serviceRequest.division)? serviceRequestStatusCombo.find(status => status.value == serviceRequest.division).cellStyle: ''">
                        {{$t('pages_servicerequest.division.'+ serviceRequest.division)}}
                      </p>
                    </div>
                  </div>
                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-receive-date-label"
                      >{{ $t('pages_servicerequest.info.receiveDate') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-receive-date-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.receiveDate">{{ serviceRequest.receiveDate }} </span>
                      </p>
                    </div>
                  </div>

                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-update-date-label"
                      >{{ $t('pages_servicerequest.info.updateDate') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-update-date-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.updateDate">{{ serviceRequest.updateDate }} </span>
                      </p>
                    </div>
                  </div>

                  <div class="-row">
                    <div class="-row-header">
                      <h5 class="-font-size-12"
                        id="service-request-info-id-label"
                      >{{ $t('pages_servicerequest.info.id') }}</h5>
                    </div>
                    <div class="-row-contents">
                      <p class="-wrapper-v-center"
                        id="service-request-info-id-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.id">{{ serviceRequest.id }} </span>
                      </p>
                    </div>
                  </div>

                </div>
              </section>
            </div>
            <div class="-width-100 -tile-container nowrap- white-space-normal">
              <section class="-wrapper-tile" >
                <div class="-div-table -pt-0">
                  <div class="-row">
                    <div class="-row-header" style="width: 15%;">
                      <h5 class="-font-size-12"
                        id="service-request-info-content-label"
                      >{{ $t('pages_servicerequest.info.content') }}</h5>
                    </div>
                    <div class="-row-contents" style="overflow-x: auto;">
                      <p class="-wrapper-v-center"
                        id="service-request-info-content-content"
                      >
                        <span class="-font-size-14 -mr-2" v-if="serviceRequest.description"
                              v-html="serviceRequest.description"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div  v-for="conversation in serviceRequest.conversations" :key="conversation.id" class="-width-100 -tile-container nowrap- white-space-normal">
              <section class="-wrapper-tile">
                <div class="-div-table -pt-0">
                  <div class="-row">
                    <div class="-row-header" style="width: 15%;">
                      <h5 class="-font-size-12">{{ $t('pages_servicerequest.info.conversation') }}</h5>
                      <h5 class="-font-size-12">{{ parseDate(conversation.updated_at) }}</h5>
                    </div>
                    <div class="-row-contents" style="overflow-x:auto">
                      <p class="-wrapper-v-center">
                        <span class="-font-size-14 -mr-2" v-if="conversation.body"
                              v-html="conversation.body"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>


          </section>
        </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment';

export default {
  name: 'servicerequest-info',
  componentName: 'ServiceRequestInfo',
  data() {
    return {
      paths: [{
        path: '/servicerequest/list',
        name: this.$t('pages_servicerequest_list.path')
      }, {
        name: this.$t('pages_servicerequest_info.path')
      }],
      divisionStyle: {
        'open': '-tag red-',
        'pending': '-tag yellow-',
        'resolved': '-tag green-',
        'done': '-tag gray-'
      }
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('servicerequest', ['serviceRequest', 'serviceRequestStatusCombo']),
  },
  methods: {
    ...mapActions('servicerequest', ['getServiceRequest', 'getServiceRequestStatusCombo']),
    parseDate(utc_datetime){
      var T_pos = utc_datetime.indexOf('T');
      var Z_pos = utc_datetime.indexOf('Z');
      var year_month_day = utc_datetime.substr(0,T_pos);
      var hour_minute_second = utc_datetime.substr(T_pos+1,Z_pos-T_pos-1);
      var new_datetime = year_month_day+" "+hour_minute_second; 
 
      timestamp = new Date(Date.parse(new_datetime));
      timestamp = timestamp.getTime();
      timestamp = timestamp/1000;
      var timestamp = timestamp+ 9*60*60;
 
    var localtime = new Date(parseInt(timestamp) * 1000);
    return moment(localtime).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  async mounted(){
    this.$showSpinner(true)
    const id = this.$route.query.id
    await this.getServiceRequest(id)
    await this.getServiceRequestStatusCombo()
    this.$showSpinner(false)
  },
  beforeMount() {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/servicerequest/ServiceRequestInfo.vue